import { useState } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { Loader2, Send } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { api, errMsg } from "@/lib/api";
import { useQueueJob } from "@/lib/useQueueJob";
import { StatusChip } from "@/components/app/StatusChip";

export function TestSend({ defaultTo }) {
  const qc = useQueryClient();
  const [to, setTo] = useState(defaultTo);
  const [jobId, setJobId] = useState(null);
  const [result, setResult] = useState(null);
  const qjob = useQueueJob(jobId, {
    onCompleted: (d) => {
      setResult(d.result);
      qc.invalidateQueries({ queryKey: ["outbox"] });
      d.result?.sent ? toast.success(`Test email sent to ${to}`) : toast.warning(d.result?.detail || "Email not sent");
    },
    onFailed: (d) => { setResult({ status: "Failed", detail: d.error }); toast.error(d.error); },
  });
  const busy = jobId && qjob && !["completed", "failed"].includes(qjob.status);
  const send = async () => {
    setResult(null);
    try {
      const { data } = await api.post("/settings/email/test", { to });
      setJobId(data.job_id);
      toast("Test email queued");
    } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <div className="space-y-2">
      <div className="flex flex-wrap items-center gap-2">
        <Input type="email" value={to} onChange={(e) => setTo(e.target.value)} className="w-72" aria-label="Send test email to" data-testid="email-test-to-input" />
        <Button variant="outline" onClick={send} disabled={busy} data-testid="email-send-test-btn">
          {busy ? <Loader2 size={16} className="animate-spin" /> : <Send size={16} />} Send test email
        </Button>
      </div>
      {result && <p className="flex items-center gap-2 text-sm text-ink-secondary" data-testid="email-test-result"><StatusChip status={result.status} /> {result.detail}</p>}
    </div>
  );
}
